import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change(event: Event) {
    let newURL = new URL(window.location.href)
    newURL.searchParams.set("order", event.target.options[event.target.selectedIndex].value)
    Turbo.visit(newURL.toString())
  }
}
